module.exports = __webpack_public_path__ + "img/symbol_11.63c87aaf.png";